import { render, staticRenderFns } from "./UploadTemplatePreference.vue?vue&type=template&id=180ed782&scoped=true"
import script from "./UploadTemplatePreference.vue?vue&type=script&lang=js"
export * from "./UploadTemplatePreference.vue?vue&type=script&lang=js"
import style0 from "./UploadTemplatePreference.vue?vue&type=style&index=0&id=180ed782&prod&lang=scss"
import style1 from "./UploadTemplatePreference.vue?vue&type=style&index=1&id=180ed782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ed782",
  null
  
)

export default component.exports